t = require('app/scripts/views/internal/teacup-with-helpers')('popover_move_card')

module.exports = ->
  suggestions = t.mustacheVar('suggestions')
  if suggestions.length > 0
    t.div '.pop-over-section.js-suggestions', ->
      t.h4 ->
        t.icon 'sparkle'
        t.format 'suggested'

      for list in suggestions
        t.a '.button-link.js-suggested-move', {
          class: t.classify({
            'flip-icon': list.direction == 'left'
          }),
          'data-id': list.id,
          'data-position': list.position,
          href: '#'
        }, ->
          t.icon 'move'
          t.text list.name

      t.a '.suggested-actions-feedback.js-suggested-actions-feedback', { href: '#' }, ->
        t.format 'feedback'

  t.div '.pop-over-section', ->
    t.h4 ->
      t.format 'select-destination'

    t.mustachePartial 'move_card_controls'

    t.input '.primary.wide.js-submit', { type: 'submit', value: t.l('move') }
